import t from 'react-translate';
import { TabTypes } from '../learner-progress-tabs';
import { DefaultMessageVariant } from './contact-learners-form';

/**
 * react-translate returns any value containing HTML as a React
 * <span dangerouslySetInnerHTML> element instead of a raw string. The body
 * defaults are HTML, so unwrap that element back into the raw HTML string the
 * Froala editor and email preview expect. Plain-text values pass through.
 */
const toRawString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  const html = (value as { props?: { dangerouslySetInnerHTML?: { __html?: string } } })
    ?.props?.dangerouslySetInnerHTML?.__html;
  return typeof html === 'string' ? html : '';
};

/**
 * Maps the active dashboard tab to the appropriate prefill copy variant.
 * Total / Completed / Never Active have dedicated copy; everything else
 * (saved views, In Progress, Missed Deadline, filtered views) falls back
 * to the FILTERED variant. An unsaved filter (Filters flyout applied but not
 * saved as a view) always uses FILTERED too, regardless of the tab behind it.
 */
const getDefaultMessageVariant = (activeTab: string, hasUnsavedFilters = false): DefaultMessageVariant => {
  const variant = (() => {
    if (hasUnsavedFilters) return t.LEARNER_PROGRESS.CONTACT_BAR.DEFAULTS.FILTERED;
    switch (activeTab) {
      case TabTypes.TOTAL:
        return t.LEARNER_PROGRESS.CONTACT_BAR.DEFAULTS.TOTAL;
      case TabTypes.COMPLETED:
        return t.LEARNER_PROGRESS.CONTACT_BAR.DEFAULTS.COMPLETED;
      case TabTypes.NEVER_ACTIVE:
        return t.LEARNER_PROGRESS.CONTACT_BAR.DEFAULTS.NEVER_ACTIVE;
      default:
        return t.LEARNER_PROGRESS.CONTACT_BAR.DEFAULTS.FILTERED;
    }
  })();

  return {
    subject: toRawString(variant.SUBJECT()),
    body: toRawString(variant.BODY()),
    pushMessage: toRawString(variant.PUSH_MESSAGE()),
  };
};

export default getDefaultMessageVariant;
